import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
    TIMESLOT_ADD_ACTION_TYPE,
    TIMESLOT_DELETE_ACTION_TYPE,
    TIMESLOT_DETAIL_ACTION_TYPE,
    TIMESLOT_LIST_ACTION_TYPE,
  headers, timeSlotAddUrl, timeSlotDeleteUrl, timeSlotDetailUrl, timeSlotListUrl,
} from "../../utils/constants";
import moment from "moment";

export const timeslot_list_action = (TimeSlotName,FromTime,ToTime, Status) => async (dispatch) => {
  try {
    const mapdata = {
      userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      TimeSlotName: TimeSlotName.toString().trim(),
      FromTime: FromTime != null && FromTime != 'null' ? FromTime : null,
      ToTime: ToTime != null && ToTime != 'null' ? ToTime : null,
      Status: Status==1?1:Status==0?0:null,
    };
    const params = {
      userId:mapdata.userId==""?null:mapdata.userId,
      TimeSlotName: mapdata.TimeSlotName == "" ? null : mapdata.TimeSlotName,
      FromTime:mapdata.FromTime==""?null:mapdata.FromTime,
      ToTime:mapdata.ToTime==""?null:mapdata.ToTime,
      Status: mapdata.Status,
    };
    console.log("timeslot mapdata...", mapdata);
    const res = await axiosGet(timeSlotListUrl, params,headers);
    console.log("timeslot", res);
    dispatch({
      type: TIMESLOT_LIST_ACTION_TYPE,
      payload: res,
    });
    return res; // No need to wrap in Promise.resolve()
  } catch (err) {
    return Promise.reject(err);
  }
};

  export const timeslot_detail_action = (TimeSlotID) => async (dispatch) => {
    try {
      const params = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
          TimeSlotID: TimeSlotID ? TimeSlotID.toString().trim() : "",
      };
      console.log("timeslot detail mapdata...", params);
      const res = await axiosGet(timeSlotDetailUrl, params,headers);
      console.log("detailstimeslot", res);
      dispatch({
        type: TIMESLOT_DETAIL_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const timeslot_add_action = (
  TimeSlotID,
  TimeSlotName,
  FromTime,
  ToTime,SelectedHrs,Description,finalStatus
) => async (dispatch) => {
  try {
    const mapdata = {
      userId:  sessionStorage.getItem("userId") == "" ||
      sessionStorage.getItem("userId") == null
        ? ""
        : sessionStorage.getItem("userId"),
      TimeSlotID: TimeSlotID ? TimeSlotID.toString().trim() : null,
      TimeSlotName: TimeSlotName?TimeSlotName.toString().trim():null,
      FromTime: FromTime?FromTime.toString().trim():null,
      ToTime: ToTime?ToTime.toString().trim():null,
      SelectedHrs: SelectedHrs?SelectedHrs.toString().trim():null,
      Description: Description?Description.toString().trim():null,
      Status: finalStatus==1?finalStatus:0,
    };
    console.log("timeslot add mapdata...", mapdata);

    const res = await axiosPost(timeSlotAddUrl, mapdata, headers);
    dispatch({
      type: TIMESLOT_ADD_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};


export const timeslot_delete_action =(TimeSlotID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        TimeSlotID: TimeSlotID ? TimeSlotID.toString().trim() : "",
      };

      const res = await axiosGet(timeSlotDeleteUrl, mapdata,headers);
      dispatch({
        type: TIMESLOT_DELETE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
